<template lang='pug' src='./nav-desktop.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  computed: {
    links () {
      return this.$router.options.routes
    },
    classList () {
      return {
        'top': !this.$store.state.nav
      }
    }
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// nav-desktop.vue?06bbf6c2